<template>
    <div class="template template--basic">

        <sidebar :user="user" :isFloating="true" ></sidebar>
        <router-view class="page-view"></router-view>

    </div>
</template>


<script>
import Sidebar from 'js/admin/components/sidebar/Sidebar.vue'

export default {
    name: 'BasicTemplate',
    components: { Sidebar },
    vuex: {
        getters: {
            user: state => state.users.current,
        },
    },
}
</script>


<style lang="scss">

    @import 'global';

</style>



// WEBPACK FOOTER //
// BasicTemplate.vue?61f062f6